import { useEffect, useState , useRef } from "react";
import { Card, Accordion } from 'react-bootstrap';
import OverlayContainer from '../OverlayContainer';
import Select from "react-dropdown-select";
import  CustomDropdown  from '../CustomDropdown';
import  CustomControl  from '../CustomControl';
import  CustomDropdownWithSearch  from '../CustomDropdownWithSearch';
import { DebounceInput } from 'react-debounce-input';
import  CustomDropdownMulti  from '../CustomDropdownMulti';
import  CustomControlMulti  from '../CustomControlMulti';
import {
  capitalizeWordsText,
} from "../../Functions/TextTransform";

export default function Step9CcomponentPleatedSheer({
  step8,
  step2B,
  depSet,
  accordionActiveKey,
  ContextAwareToggle,
  t,
  requiredStep,
  stepSelectedLabel,
  step2C,
  tracksList2,
  rodsList4,
  step8C,
  setStep8C1,
  setStep8C2,
  setStep8C3,
  setSelectedPrivacyLayer,
  setStep8C,
  extendedTitle,
  setExtendedTitle,
  setDeps,
  setCart,
  selectChanged,
  inputs,
  modalHandleShow,
  setHardwarePLWarningTemp,
  widthCart,
  step6DHead,
  step6C,
  step6,
  setStep6CHead,
  trackType8C,
  rodsColorList4,
  step8C3,
  modelAccessories,
  GetPrice,
  pageLanguage,
  isTabletOrMobile,
  motorErr1,
  step8C5,
  setStep8C5,
  setMotorErr1,
  selectedMotorPositionC,
  setSelectedMotorPositionC,
  selectedRemoteName,
  setSelectedRemoteName,
  showRemoteName,
  setSelectedMotorChannelsC,
  motorChannels,
  selectUncheck,
  setRemoteNameC,
  selectedMotorChannelsC,
  pageLoad,
  rodsLoad,
  rodsLoad2,
  MotorPosition,
  remoteNames,
  setShowRemoteName,
  setCartLoading,
  remoteNameC,
  Capitalize,
  selectedPrivacyLayer,
  privacyLayerSelect3,
  privacyLayerSelect,
  privacyLayerSelect2,
  NextStep,
  step31,
  step3,
  step6BHead,
  step9ADrapery,
  selectedSheer,
  step8B,
  setStep8CTrack,
  step8CTrack
}) {
  const [isDisabled, setIsDisabled] = useState(false);
  const [isDisabledRod, setIsDisabledRod] = useState(false);
  const [layerDraperyOptions, setLayerDraperyOptions] = useState(null);
  const motorChannelsUserOpenRefB = useRef(false);

  useEffect(() => {
    let newIsDisabled;
    let newIsDisabledRod;
    if (step31 === "false" && parseInt(widthCart) <= 160) {
      newIsDisabled = false;
    } else if (step6DHead === "Track") {
      newIsDisabled = false;
    } else if (step6DHead === "Rod" && parseInt(widthCart) > 160) {
      newIsDisabled = true;
    } else if (step3 === "false" && parseInt(widthCart) <= 160) {
      newIsDisabled = false;
    } else if (step3 === "true" && parseInt(widthCart) <= 160 && step31 === "true") {
      newIsDisabled = true;
    } 

    if (step6DHead === "Rod" && parseInt(widthCart) > 160 ) {
      newIsDisabledRod = false;
    } else if (step6DHead === "Track" && parseInt(widthCart) > 160 ) {
      newIsDisabledRod = true;
    } else if (step6DHead === "Track" && parseInt(widthCart) <= 160 && step31 === 'true' && step3 === "true"  ) {
      newIsDisabledRod = true;
    } else if (step6DHead === "Track" && parseInt(widthCart) <= 160 && step31 === "Track" && step3 === "true"  ) {
      newIsDisabledRod = true;
    } else if (step6BHead === "Rod" && parseInt(widthCart) <= 160 && step31 === "false" && step3 === "true" && step9ADrapery === "Track"  ) {
      newIsDisabledRod = true;
    } else if (step6BHead === "Rod" && parseInt(widthCart) <= 160 && step31 === "false" && step3 === "true" && step8B === "Track"  ) {
      newIsDisabledRod = true;
    }  else if (step6BHead === "Rod" && parseInt(widthCart) <= 160 && step31 === "" && step3 === "false" && step8B === "Track"  ) {
      newIsDisabledRod = true;
    } else  if (selectedSheer && selectedSheer[0] && (selectedSheer[0].num === "3" || selectedSheer[0].num === "4" || selectedSheer[0].num === "5")  && step31 === "" && parseInt(widthCart) <= 160 && step3 === "false" ) {
      newIsDisabledRod = true;
    } else {
      newIsDisabledRod = false;
    }

    if (selectedSheer && selectedSheer[0] && (selectedSheer[0].num === "3" || selectedSheer[0].num === "4" || selectedSheer[0].num === "5")  && step31 === "false" && parseInt(widthCart) <= 160 ) {
      setLayerDraperyOptions(privacyLayerSelect2[pageLanguage]);
    } else if (selectedSheer && selectedSheer[0] && (selectedSheer[0].num === "3" || selectedSheer[0].num === "4" || selectedSheer[0].num === "5")  && step31 === "" && parseInt(widthCart) <= 160 && step3 === "false" ) {
      setLayerDraperyOptions(privacyLayerSelect2[pageLanguage]);
    } else   if (parseInt(widthCart) <= 160 && step31 !== "true" && step3 !== "true") {
      setLayerDraperyOptions(privacyLayerSelect3[pageLanguage]);
    } else if (parseInt(widthCart) <= 160 && step31 === "false" && step3 === "true" && step6DHead === "Rod" && step9ADrapery === "Track") {
      setLayerDraperyOptions(privacyLayerSelect2[pageLanguage]);
    } else if (parseInt(widthCart) <= 160 && step31 === "true" && step3 === "true" && step6DHead === "Rod") {
      setLayerDraperyOptions(privacyLayerSelect[pageLanguage]);
    }  else if (parseInt(widthCart) <= 160 && step31 === "false" && step3 === "true") {
      setLayerDraperyOptions(privacyLayerSelect3[pageLanguage]);
    } else if (step6DHead === "Rod") {
      setLayerDraperyOptions(privacyLayerSelect[pageLanguage]);
    } else if ( parseInt(widthCart) <= 160 && step31 === "true" && step3 === "true" && step6DHead === "Track") {
      setLayerDraperyOptions(privacyLayerSelect2[pageLanguage]);
    } else {
      setLayerDraperyOptions(privacyLayerSelect2[pageLanguage]);
    }

    setIsDisabled(newIsDisabled);
    setIsDisabledRod(newIsDisabledRod);

    if (step8C === "Rod" && step8B === "Track") {
      setStep8C("");
      setStep8C1("");
      setStep8C3("");
     setDeps("8C", "");
     let tempExtended = extendedTitle;
      tempExtended["8C"] = [t("")];
      setExtendedTitle(tempExtended);
   }
   
  }, [step31, widthCart, step6DHead, step3, pageLanguage , step9ADrapery , selectedSheer , step8B]);
  return (
   <Card
   className={
     step8 === "I Want To Customize Hardware Per Curtain" && step2B !== "None"
       ? ""
       : "noDisplay"
   }
 >
   <Card.Header
     className={
       [...depSet].findIndex((el) => el.startsWith("8")) === -1 &&
       !accordionActiveKey.startsWith("8")
         ? "hidden"
         : ""
     }
   >
     <ContextAwareToggle
       eventKey="8C"
       stepNum={t("6B")}
       stepTitle={t("grommet_step8C")}
       stepRef="8C"
       type="1"
       required={requiredStep["8C"]}
       stepSelected={
         stepSelectedLabel["8C"] === undefined ? "" : stepSelectedLabel["8C"]
       }
     />
   </Card.Header>
   <Accordion.Collapse eventKey="8C">
     <Card.Body>
       <div
         className={
           step2B !== "None" && step2C === ""
             ? "card_body card_body_radio card_body_hardware"
             : "noDisplay"
         }
       >
         <div className="checkbox_text_info_container">
           <div className="card-body-display-flex">
             <span className="checkbox_text">{t("pl_hs_incomplete2")}</span>
           </div>
         </div>
       </div>
       <div
         className={
           step2B !== "None" && step2C !== ""
             ? "card_body2 card_body_radio card_body_radio_new card_body_hardware" +
               (tracksList2.length > 0 && rodsList4.length > 0 ? "" : "")
             : "noDisplay"
         }
       >
         <div className="boxHardware  radio_style">
           <input
             className="radio"
             type="radio"
             text={t("None")}
             value="1"
             name="step8C"
             ref-num="8C"
             id="8C1"
             checked={step8C === "None"}
             onChange={(e) => {
               setStep8C1("");
               setStep8CTrack("");
               setStep8C2("");
               setStep8C3("");
               setSelectedPrivacyLayer([]);
               setDeps("87","8C,858,859,860,861,862,863,864,865");
               setStep8C("None");
               let tempExtended = extendedTitle;
               tempExtended["8C"] = [t("None")];
               setExtendedTitle(tempExtended);
              
               setCart(
                 "PrivacyLayerHardware",
                 "None",
                 "RailIdC,BatonOptionC,ControlPositionC,RailDesignC,RailDesignEnC,RailDesignFaC,RailColorEnC,RailColorFaC,RodColorC,hardwarePrivacyLayer"
               );
               selectChanged(e);
             }}
             ref={(ref) => (inputs.current["8C1"] = ref)}
           />
           <label htmlFor="8C1">{t("None")}</label>
         </div>
         <div className={rodsList4.length > 0 ? "boxHardware  radio_style" : "noDisplay"}>
           <input
             className="radio"
             type="radio"
             text={t("pl_Rod")}
             value="3"
             name="step8C"
             ref-num="8C"
             id="8C3"
             checked={step8C === "Rod"}
             disabled={isDisabledRod}
             onChange={(e) => {
               if (
                 parseInt(widthCart) > 160 &&
                 step6DHead === "Track" &&
                 step6C !== ""
               ) {
                 modalHandleShow("hardwarePLWarning");
                 setHardwarePLWarningTemp({
                   stepValue: "Rod",
                   id: "pl_Rod",
                   cartValue: "Rod",
                   event: e,
                 });
               } else {
                 setStep8C1("");
                 setStep8CTrack("");
                 setStep8C2("");
                 setStep8C3("");
                 setDeps("858","8C,87,859,860,861,862,863,864,865");
                 setTimeout(() => {
                   setStep8C("Rod");
                   if (step6 !== "Customize Style Per Curtain") {
                     setStep6CHead("Rod");
                   }
                 }, 300);
                 let tempExtended = extendedTitle;
                 tempExtended["8C"] = [t("pl_Rod")];
                 setExtendedTitle(tempExtended);
                
                 setCart(
                   "PrivacyLayerHardware",
                   "Rod",
                   "RailIdC,BatonOptionC,ControlPositionC,RailDesignC,RailDesignEnC,RailDesignFaC,RailColorEnC,RailColorFaC,RodColorC,hardwarePrivacyLayer"
                 );
                 selectChanged(e);
               
               }
             }}
             ref={(ref) => (inputs.current["8C3"] = ref)}
           />
           <label htmlFor="8C3">
             {t("pl_Rod")}
             <br />
             { 
            isDisabledRod &&  (
                 <OverlayContainer
                   classNames="extension_unavailable"
                   placement="bottom"
                   children={
                     <div className="extension_unavailable_title text_underline">
                       {t("Why is this unavailable?")}
                     </div>
                   }
                   component={
                     <div className="extension_unavailable_container">
                       <div className="extension_unavailable_text">
                         {t("track_sheer_hardware_text")}
                       </div>
                     </div>
                   }
                 />
               )}
           </label>
         </div>
         <div className={tracksList2.length > 0 ? "boxHardware  radio_style" : "noDisplay"}>
           <input
             className="radio"
             type="radio"
             text={t("pl_Track")}
             value="2"
             name="step8C"
             ref-num="8C"
             id="8C2"
             checked={step8C === "Track"}
             disabled={isDisabled}
             onChange={(e) => {
               if (parseInt(widthCart) > 160 && step6DHead === "Rod" && step6C !== "") {
                 modalHandleShow("hardwarePLWarning");
                 setHardwarePLWarningTemp({
                   stepValue: "Track",
                   id: "pl_Track",
                   cartValue: "Track",
                   event: e,
                 });
               } else {
                 setStep8C1("");
                 setStep8CTrack("");
                 setStep8C2("");
                 setStep8C3("");
                 setDeps("858","8C,87,859,860,861,862,863,864,865");
                 setTimeout(() => {
                   setStep8C("Track");
                   if (step6 !== "Customize Style Per Curtain") {
                     setStep6CHead("Track");
                   }
                 }, 300);
                 let tempExtended = extendedTitle;
                 tempExtended["8C"] = [t("pl_Track")];
                 setExtendedTitle(tempExtended);
               
                 setCart(
                   "PrivacyLayerHardware",
                   "Track",
                   "RailIdC,BatonOptionC,ControlPositionC,RailDesignC,RailDesignEnC,RailDesignFaC,RailColorEnC,RailColorFaC,RodColorC,hardwarePrivacyLayer"
                 );
                 selectChanged(e);
                
               }
             }}
             ref={(ref) => (inputs.current["8C2"] = ref)}
           />
           <label htmlFor="8C2">
             {t("pl_Track")}
             <br />
             {
              isDisabled && (
                 <OverlayContainer
                   classNames="extension_unavailable"
                   placement="bottom"
                   children={
                     <div className="extension_unavailable_title text_underline">
                       {t("Why is this unavailable?")}
                     </div>
                   }
                   component={
                     <div className="extension_unavailable_container">
                       <div className="extension_unavailable_text">
                         {t("rod_sheer_hardware_text")}
                       </div>
                     </div>
                   }
                 />
               )}
           </label>
         </div>
         

         {/* step 10 Questions */}
         <div
           className={
             step8C !== "None" && step8C !== ""
               ? "card_body card_body_radio card_body_Rod"
               : "noDisplay"
           }
         >
            <div className="box100">
            <p className="step_selection_title">

            {step8C === "Rod" ? t("Rod Collection") : t("Track Collection")}
            </p>
           </div>
           {step8C === "Rod" ? rodsList4 : tracksList2}
         </div>
         <div
           className={
             step8C !== "None" && step8C !== "" && step8CTrack !== "" && !trackType8C
               ? "card_body card_body_radio card_body_Rod_color bracket_color"
               : "noDisplay"
           }
         >
           <div className="box100">
             <p className="step_selection_title">
               {step8C === "Rod"
                 ? t("step8_rod_finish_title")
                 : t("step8_rod_finish_title_track")}
             </p>
           </div>
           {rodsColorList4}
         </div>
         <div
           className={
             step8C !== "None" && step8C !== "" && step8CTrack !== "" && trackType8C === 2
               ? "card_body card_body_radio card_body_Rod_color bracket_color"
               : "noDisplay"
           }
         >
           <div className="box100">
             <p className="step_selection_title">
               {step8C === "Rod"
                 ? t("step8_rod_finish_title")
                 : t("step8_rod_finish_title_track")}
             </p>
           </div>
           {rodsColorList4}
         </div>

         <div
           className={
             step8C !== "None" && step8C !== "" && step8CTrack !== "" && !trackType8C
               ? "card_body card_body_radio card_body_baton"
               : "noDisplay"
           }
         >
           <div className="box100">
             <p className="step_selection_title">
               {t("Baton Option")}
             </p>
           </div>
           <div className="box33 radio_style baton_style">
             <input
               className="radio"
               type="radio"
               text={t("None")}
               value="1"
               name="step8C3"
               ref-num="8"
               id="8C31"
               checked={step8C3 === "None"}
               onChange={(e) => {
                 setStep8C3("None");
                 setDeps("", "8A,8A1,8A2,8B,8B1,8B2,8C,8C1,8C2,860,861", 1);
                 setCart("BatonOptionC", "None");
                 selectChanged(e);
                 let tempExtended = extendedTitle;
                 tempExtended["8C"][3] = (
                   <li key="3" className="step_title_extended_list_item">
                     <span className="step_title_extended_list_item_title">
                       {t("Baton")}
                     </span>
                     <span className="step_title_extended_list_item_text">
                       {t("None")}
                     </span>
                   </li>
                 );
                 setExtendedTitle(tempExtended);
               }}
               ref={(ref) => (inputs.current["8C31"] = ref)}
             />
             <label htmlFor="8C31">{t("None")}</label>
           </div>
           <div className="box33 radio_style baton_style">
             <input
               className="radio"
               type="radio"
               text={t("Baton 30cm")}
               value="2"
               name="step8C3"
               ref-num="8"
               id="8C32"
               checked={step8C3 === "Baton 30cm"}
               onChange={(e) => {
                 setStep8C3("Baton 30cm");
                 setDeps("", "8A,8A1,8A2,8B,8B1,8B2,8C,8C1,8C2,860,861", 1);
                 setCart("BatonOptionC", "Baton 30cm");
                 selectChanged(e);
                 let tempExtended = extendedTitle;
                 tempExtended["8C"][3] = (
                   <li key="3" className="step_title_extended_list_item">
                     <span className="step_title_extended_list_item_title">
                       {t("Baton")}
                     </span>
                     <span className="step_title_extended_list_item_text">
                       {t("Baton 30cm")}
                     </span>
                   </li>
                 );
                 setExtendedTitle(tempExtended);
               }}
               ref={(ref) => (inputs.current["8C32"] = ref)}
             />
             <label htmlFor="8C32">
               {t("Baton 30cm")}
               <br />
               <p className="surcharge_price">
                 {Object.keys(modelAccessories).length !== 0
                   ? t("Add ")
                   : t("Surcharge Applies")}
                 {modelAccessories["27"]
                   ? modelAccessories["27"]["58"]
                     ? GetPrice(
                         modelAccessories["27"]["58"]["Price"],
                         pageLanguage,
                         t("TOMANS"),
                         isTabletOrMobile
                       )
                     : null
                   : null}
               </p>
             </label>
           </div>
           <div className="box33 radio_style baton_style">
             <input
               className="radio"
               type="radio"
               text={t("Baton 45cm")}
               value="3"
               name="step8C3"
               ref-num="8"
               id="8C33"
               checked={step8C3 === "Baton 45cm"}
               onChange={(e) => {
                 setStep8C3("Baton 45cm");
                 setDeps("", "8A,8A1,8A2,8B,8B1,8B2,8C,8C1,8C2,860,861", 1);
                 setCart("BatonOptionC", "Baton 45cm");
                 selectChanged(e);
                 let tempExtended = extendedTitle;
                 tempExtended["8C"][3] = (
                   <li key="3" className="step_title_extended_list_item">
                     <span className="step_title_extended_list_item_title">
                       {t("Baton")}
                     </span>
                     <span className="step_title_extended_list_item_text">
                       {t("Baton 45cm")}
                     </span>
                   </li>
                 );
                 setExtendedTitle(tempExtended);
               }}
               ref={(ref) => (inputs.current["8C33"] = ref)}
             />
             <label htmlFor="8C33">
               {t("Baton 45cm")}
               <br />
               <p className="surcharge_price">
                 {Object.keys(modelAccessories).length !== 0
                   ? t("Add ")
                   : t("Surcharge Applies")}
                 {modelAccessories["27"]
                   ? modelAccessories["27"]["59"]
                     ? GetPrice(
                         modelAccessories["27"]["59"]["Price"],
                         pageLanguage,
                         t("TOMANS"),
                         isTabletOrMobile
                       )
                     : null
                   : null}
               </p>
             </label>
           </div>
          
         </div>
         <div
           className={
             step8C !== "None" && step8C !== "" && step8CTrack !== "" && trackType8C === 2
               ? "card_body card_body_radio card_body_baton"
               : "noDisplay"
           }
         >
           <div className="box100">
             <p className="step_selection_title">{t("Control Position")}</p>
           </div>
           <div className="box33 radio_style">
             <div className="width_max">
               <img
                 src={require("../../Images/drapery/grommet/cp_hardware_left.svg").default}
                 className="img-fluid"
                 alt=""
               />
               <input
                 className="radio"
                 type="radio"
                 text={t("Left")}
                 value="5"
                 name="step8C3"
                 ref-num="8"
                 id="8C35"
                 checked={step8C3 === "Left"}
                 onChange={(e) => {
                   setStep8C3("Left");
                   setDeps("", "8A,8A1,8A2,8B,8B1,8B2,8C,8C1,8C2,862", 1);
                   setCart("ControlPositionC", "Left Control");
                   selectChanged(e);
                   let tempExtended = extendedTitle;
                   tempExtended["8C"][3] = (
                     <li key="3" className="step_title_extended_list_item">
                       <span className="step_title_extended_list_item_title">
                         {t("Control Position")}
                       </span>
                       <span className="step_title_extended_list_item_text">
                         {t("Left")}
                       </span>
                     </li>
                   );
                   setExtendedTitle(tempExtended);
                 }}
                 ref={(ref) => (inputs.current["8C35"] = ref)}
               />
               <label htmlFor="8C35">{t("Left")}</label>
             </div>
           </div>
           <div className="box33 radio_style">
             <div className="width_max">
               <img
                 src={require("../../Images/drapery/grommet/cp_hardware_right.svg").default}
                 className="img-fluid"
                 alt=""
               />
               <input
                 className="radio"
                 type="radio"
                 text={t("Right")}
                 value="2"
                 name="step8C6"
                 ref-num="8"
                 id="8C36"
                 checked={step8C3 === "Right"}
                 onChange={(e) => {
                   setStep8C3("Right");
                   setDeps("", "8A,8A1,8A2,8B,8B1,8B2,8C,8C1,8C2,862", 1);
                   setCart("ControlPositionC", "Right Control");
                   selectChanged(e);
                   let tempExtended = extendedTitle;
                   tempExtended["8C"][3] = (
                     <li key="3" className="step_title_extended_list_item">
                       <span className="step_title_extended_list_item_title">
                         {t("Control Position")}
                       </span>
                       <span className="step_title_extended_list_item_text">
                         {t("Right")}
                       </span>
                     </li>
                   );
                   setExtendedTitle(tempExtended);
                 }}
                 ref={(ref) => (inputs.current["8C36"] = ref)}
               />
               <label htmlFor="8C36">{t("Right")}</label>
             </div>
           </div>
         </div>

         <div className={step8CTrack === "2208" ? "tracks_motorized_section" : "noDisplay"}>
           <div
             className={
               motorErr1
                 ? "secondary_options secondary_options_err"
                 : "secondary_options"
             }
           >
             <div className="card-body-display-flex">
               <div className="width_max checkbox_style">
                 <input
                   type="checkbox"
                   text={t("Motorized")}
                   value="1"
                   name="step8C5"
                   ref-num="8C5"
                   checked={step8C5 === "true"}
                   onChange={(e) => {
                     if (e.target.checked) {
                       selectChanged(e);
                       setStep8C5("true");
                       setMotorErr1(false);
                       setSelectedMotorPositionC([]);
                       setDeps("863,864,865", "87");
                       setSelectedRemoteName([]);
                       setSelectedMotorChannelsC([
                         motorChannels[pageLanguage].find((opt) => opt.value === "0"),
                       ]);
                       setRemoteNameC("");
                       
                       setCart("hasPowerC", true, "", "MotorChannelsC", [
                         selectedMotorChannelsC.map((obj) => obj.value),
                       ]);
                     } else {
                       selectUncheck(e);
                       setStep8C5("");
                       setDeps("87", "863,864,865");
                       setCart(
                         "",
                         "",
                         "hasPowerC,MotorPositionC,RemoteNameC,MotorChannelsC"
                       );
                     }
                   }}
                   id="8C51"
                   ref={(ref) => (inputs.current["8C51"] = ref)}
                 />
                 <label htmlFor="8C51" className="checkbox_label">
                   <img
                     className="checkbox_label_img checkmark1 img-fluid"
                     src={require("../../Images/public/checkmark1_checkbox.png")}
                     alt=""
                   />
                 </label>
                 <span className="checkbox_text">{t("Motor_title")}</span>
               </div>
             </div>
           </div>
           {motorErr1 && <div className="input_not_valid">{t("motorErr1")}</div>}
           <div
             className={
               trackType8C === 1 && step8C5 === "true"
                 ? "motorized_options"
                 : "noDisplay"
             }
           >
             <div className="motorized_option_left">
               <p>{t("Motor Position")}</p>
               &nbsp;
               <span onClick={() => modalHandleShow("learnMore2")}>
                 {t("(Learn More)")}
               </span>
             </div>
             <div className="motorized_option_right">
               <div className="select_container">
                 <Select
                   className="select"
                   placeholder={t("Please Select")}
                   portal={document.body}
                   dropdownPosition="bottom"
                   dropdownHandle={false}
                   dropdownGap={0}
                   ref-num="8"
                   values={selectedMotorPositionC}
                   onDropdownOpen={() => {
                     let temp1 = window.scrollY;
                     window.scrollTo(window.scrollX, window.scrollY + 1);
                     setTimeout(() => {
                       let temp2 = window.scrollY;
                       if (temp2 === temp1)
                         window.scrollTo(window.scrollX, window.scrollY - 1);
                     }, 100);
                   }}
                   dropdownRenderer={({ props, state, methods }) => (
                     <CustomDropdown props={props} state={state} methods={methods} />
                   )}
                   contentRenderer={({ props, state, methods }) => (
                     <CustomControl props={props} state={state} methods={methods} />
                   )}
                   onChange={(selected) => {
                     if (selected.length && !pageLoad && !rodsLoad && !rodsLoad2) {
                       setSelectedMotorPositionC(selected);
                       setDeps("", "8A,8A1,8A2,8B,8B1,8B2,8C,8C1,8C2,863", 2);
                       setCart("MotorPositionC", selected[0].value);
                       let tempExtended = extendedTitle;
                       tempExtended["8C"][2] = (
                         <li key="2" className="step_title_extended_list_item">
                           <span className="step_title_extended_list_item_title">
                             {t("Motor Position")}
                           </span>
                           <span className="step_title_extended_list_item_text">
                             {pageLanguage === "fa" ? selected[0].label : selected[0].value}
                           </span>
                         </li>
                       );
                     }
                   }}
                   options={MotorPosition[pageLanguage]}
                 />
               </div>
             </div>
             <div className="motorized_option_left">
               <p>{t("Remote Name")}</p>
               &nbsp;
               <span onClick={() => modalHandleShow("learnMore3")}>
                 {t("(Learn More)")}
               </span>
             </div>
             <div className="motorized_option_right">
               {!!(remoteNames.length > 1) && (
                 <div className="select_container">
                   <Select
                     className="select"
                     placeholder={t("Please Select")}
                     portal={document.body}
                     dropdownPosition="bottom"
                     dropdownHandle={false}
                     dropdownGap={0}
                     ref-num="8"
                     values={selectedRemoteName}
                     onDropdownOpen={() => {
                       let temp1 = window.scrollY;
                       window.scrollTo(window.scrollX, window.scrollY + 1);
                       setTimeout(() => {
                         let temp2 = window.scrollY;
                         if (temp2 === temp1)
                           window.scrollTo(window.scrollX, window.scrollY - 1);
                       }, 100);
                     }}
                     dropdownRenderer={({ props, state, methods }) => (
                       <CustomDropdownWithSearch
                         props={props}
                         state={state}
                         methods={methods}
                       />
                     )}
                     contentRenderer={({ props, state, methods }) => (
                       <CustomControl props={props} state={state} methods={methods} />
                     )}
                     onChange={(selected) => {
                       if (selected.length && !pageLoad && !rodsLoad && !rodsLoad2) {
                        setDeps("" , "864");
                         setSelectedRemoteName(selected);
                         if (selected[0]["value"] === "addNewRemoteName") {
                           setShowRemoteName(true);
                           setCart("", "", "RemoteNameC");
                           setRemoteNameC("");
                         } else {
                           setShowRemoteName(false);
                           setCart("RemoteNameC", selected[0]["value"]);
                           setRemoteNameC(selected[0]["value"]);
                         }
                       }
                     }}
                     options={remoteNames}
                   />
                 </div>
               )}
               {(remoteNames.length === 1 || remoteNames.length === 0) && (
                 <DebounceInput
                   debounceTimeout={1500}
                   onKeyDown={() => setCartLoading(true)}
                   className="Remote_name"
                   type="text"
                   name="Remote_name"
                   value={remoteNameC}
                   placeholder={t("Enter a name for your remote")}
                   onChange={(e) => {
                     setTimeout(() => {
                      setDeps("" , "864");
                       setCart("RemoteNameC", capitalizeWordsText(e.target.value));
                       setRemoteNameC(capitalizeWordsText(e.target.value));
                       let tempExtended = extendedTitle;
                       tempExtended["8C"][3] = (
                        <li key="3" className="step_title_extended_list_item">
                          <span className="step_title_extended_list_item_title">
                            {t("Remote_name")}
                          </span>
                          <span className="step_title_extended_list_item_text">
                            {capitalizeWordsText(e.target.value)}
                          </span>
                        </li>
                      );
                     }, 300);
                   }}
                 />
               )}
             </div>
             {showRemoteName && (
               <div className="motorized_option_left">
                 <p>&nbsp;</p>
               </div>
             )}
             {showRemoteName && (
               <div className="motorized_option_right">
                 <DebounceInput
                   debounceTimeout={1500}
                   onKeyDown={() => setCartLoading(true)}
                   className="Remote_name"
                   type="text"
                   name="Remote_name"
                   ref-num="8"
                   value={remoteNameC}
                   placeholder={t("Enter a name for your remote")}
                   onChange={(e) => {
                     setTimeout(() => {
                      setDeps("" , "864");
                       setCart("RemoteNameC", e.target.value);
                       setRemoteNameC(Capitalize(e.target.value));
                     }, 300);
                   }}
                 />
               </div>
             )}
             <div className="motorized_option_left">
               <p>{t("Channel(s)")}</p>
               &nbsp;
               <span onClick={() => modalHandleShow("learnMore4")}>
                 {t("(Learn More)")}
               </span>
             </div>
             <div className="motorized_option_right">
               <div className="select_container multi_select_container">
                 <Select
                   className="select select_motor_channels"
                   placeholder={t("Please Select")}
                   portal={document.body}
                   dropdownPosition="bottom"
                   dropdownHandle={false}
                   dropdownGap={0}
                   multi={true}
                   ref-num="8"
                   values={selectedMotorChannelsC}
                   onDropdownOpen={() => {
                    motorChannelsUserOpenRefB.current = true;
                     let temp1 = window.scrollY;
                     window.scrollTo(window.scrollX, window.scrollY + 1);
                     setTimeout(() => {
                       let temp2 = window.scrollY;
                       if (temp2 === temp1)
                         window.scrollTo(window.scrollX, window.scrollY - 1);
                     }, 100);
                   }}
                   dropdownRenderer={({ props, state, methods }) => (
                     <CustomDropdownMulti
                       props={props}
                       state={state}
                       methods={methods}
                     />
                   )}
                   contentRenderer={({ props, state, methods }) => (
                     <CustomControlMulti props={props} state={state} methods={methods} />
                   )}
                   onChange={(selected) => {
                     if (selected.length && !pageLoad && !rodsLoad && !rodsLoad2) {
                      if (motorChannelsUserOpenRefB.current) {
                        setDeps("" , "865");
                        motorChannelsUserOpenRefB.current = false;
                      }
                      
                     
                       setCart(
                         "MotorChannelsC",
                         selected.map((obj) => obj.value)
                       );
                       setSelectedMotorChannelsC(selected);
                       let tempExtended = extendedTitle;
                       tempExtended["8C"][4] = (
                         <li key="4" className="step_title_extended_list_item">
                           <span className="step_title_extended_list_item_title">
                             {t("Channel(s)")}
                           </span>
                           <span className="step_title_extended_list_item_text">
                           {selected.map(item => pageLanguage === "fa" ? item.label : item.value)
                        .join(', ')}
                           </span>
                         </li>
                       );
                     }
                   }}
                   options={motorChannels[pageLanguage]}
                 />
               </div>
             </div>
           </div>
         </div>
         <div
           className={
             step8C === "None"
               ? "card_body card_body_radio card_body_have_hardware  card_body_have_hardware_new"
               : "noDisplay"
           }
         >
           <div className="box100">
             <p className="step_selection_title step_selection_title_new">{t("step8C_haveHardware_title")}</p>
           </div>
           <div className="box-step9a">
           <div className="box50 radio_style">
             <div className="same_row_selection_title">
               {t("Privacy Layer Hardware")}
             </div>
           </div>
           <div className="box50 radio_style">
             <div className="select_container">
               <Select
                 className="select"
                 placeholder={t("Please Select")}
                 portal={document.body}
                 dropdownPosition="bottom"
                 dropdownHandle={false}
                 dropdownGap={0}
                 ref-num ='8'
                 values={selectedPrivacyLayer}
                 onDropdownOpen={() => {
                   let temp1 = window.scrollY;
                   window.scrollTo(window.scrollX, window.scrollY + 1);
                   setTimeout(() => {
                     let temp2 = window.scrollY;
                     if (temp2 === temp1)
                       window.scrollTo(window.scrollX, window.scrollY - 1);
                   }, 100);
                 }}
                 dropdownRenderer={({ props, state, methods }) => (
                   <CustomDropdown props={props} state={state} methods={methods} />
                 )}
                 contentRenderer={({ props, state, methods }) => (
                   <CustomControl props={props} state={state} methods={methods} />
                 )}
                 onChange={(selected) => {
                   if (selected.length && !pageLoad && !rodsLoad && !rodsLoad2) {
                     setCart("hardwarePrivacyLayer", selected[0].value);
                     setDeps("", "8A,8A1,8A2,8B,8B1,8B2,8C,8C1,8C2,87", 1);
                     let tempExtended = extendedTitle;
                     tempExtended["8C"][1] = (
                       <li key="1" className="step_title_extended_list_item">
                         <span className="step_title_extended_list_item_title">
                           {t("Privacy Layer HW")}
                         </span>
                         <span className="step_title_extended_list_item_text">
                           {pageLanguage === "fa"
                             ? selected[0].label
                             : selected[0].value}
                         </span>
                       </li>
                     );
                     setExtendedTitle(tempExtended);
                   //  setSelectedPrivacyLayer(selected);
                   }
                 }}
                 options={layerDraperyOptions}
               />
             </div>
           </div>
           </div>
         </div>
       </div>
       <NextStep currentStep="8C" eventKey="9">
         {t("NEXT STEP")}
       </NextStep>
     </Card.Body>
   </Accordion.Collapse>
 </Card>
  )
}
